import { useEffect } from "react";

import { observer } from "mobx-react-lite";
import Link from "next/link";
import { useParams } from "next/navigation";

import { disposeApi } from "@/api/disposeApi";
import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";
import { useLastDocForCurrentTeamUrl } from "@/utils/useLastDocForCurrentTeamUrl";

import { TeamName } from "../team-dropdown/TeamDropdown";

import { ProfileData } from "./ProfileData";
import { ProfileDocuments } from "./ProfileDocuments";

export const PublicProfile = observer(() => {
  const { teams, auth, publicProfile, doc } = useStore();
  const { teamPermalink } = useParams<{ [key: string]: string }>();
  const currentPermalink = teamPermalink || doc?.team?.permalink;
  const url = useLastDocForCurrentTeamUrl();

  useEffect(() => {
    if (!currentPermalink) {
      return;
    }

    return disposeApi(async (signal) => {
      await publicProfile.fetchTeam(currentPermalink, signal);
    });
  }, [currentPermalink, publicProfile]);

  return (
    <>
      {auth.isLoggedIn && (
        <Sidebar.Group>
          <Sidebar.Button
            className="flex flex-grow flex-nowrap items-center min-h-9.5"
            href={url}
            as={Link}
          >
            <TeamName team={teams.currentTeam} />
          </Sidebar.Button>
        </Sidebar.Group>
      )}
      <Sidebar.Group className="p-0 flex-col" shrink>
        <Sidebar.Scrollable>
          <ProfileData />
          {publicProfile.teamStatus === "loaded" && <ProfileDocuments />}
        </Sidebar.Scrollable>
      </Sidebar.Group>
    </>
  );
});
